{
  "version": 1,
  "scale_version": "behavior-pct-empirical-2026-08-05",
  "percentiles": [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    64,
    65,
    66,
    67,
    68,
    69,
    70,
    71,
    72,
    73,
    74,
    75,
    76,
    77,
    78,
    79,
    80,
    81,
    82,
    83,
    84,
    85,
    86,
    87,
    88,
    89,
    90,
    91,
    92,
    93,
    94,
    95,
    96,
    97,
    98,
    99
  ],
  "thresholds": {
    "moisture": [
      -213.5361767,
      -142.0908101,
      -113.8965486,
      -97.26218622,
      -85.21291162,
      -76.0775505,
      -68.87156473,
      -62.56041362,
      -57.0057986,
      -52.45723433,
      -48.71772538,
      -45.45438377,
      -42.64303592,
      -40.10834362,
      -37.82356102,
      -35.62323268,
      -33.54950126,
      -31.61988125,
      -29.72766328,
      -27.98885538,
      -26.39359861,
      -24.91467864,
      -23.34640377,
      -21.97332572,
      -20.63661465,
      -19.27954169,
      -17.98106645,
      -16.73282703,
      -15.50246738,
      -14.32950167,
      -13.19045703,
      -12.0520447,
      -10.79039736,
      -9.700770606,
      -8.717485987,
      -7.665777906,
      -6.575070018,
      -5.481661088,
      -4.461262354,
      -3.486230017,
      -2.456356453,
      -1.441354681,
      -0.4304110932,
      0.6630963831,
      1.670841576,
      2.710449646,
      3.759938026,
      4.737980015,
      5.756583034,
      6.726439271,
      7.771322011,
      8.865722154,
      9.899911728,
      10.89360653,
      11.88023877,
      12.94779506,
      14.01265246,
      15.06213135,
      16.09215403,
      17.11553457,
      18.20146429,
      19.35622733,
      20.53194387,
      21.70778945,
      22.92222312,
      24.18663387,
      25.46126632,
      26.66501418,
      27.88934027,
      29.26550077,
      30.4932941,
      31.95299025,
      33.33108916,
      34.81621462,
      36.34128941,
      37.85375775,
      39.54042227,
      41.2086083,
      42.79177809,
      44.46283156,
      46.33759023,
      48.18625688,
      50.12559333,
      52.23103942,
      54.21689699,
      56.42787631,
      58.82416455,
      61.28634519,
      63.97521494,
      67.15091096,
      70.67352181,
      74.20391364,
      78.57855588,
      83.42845774,
      89.06097404,
      95.48886327,
      103.9334928,
      117.3300167,
      140.0694248
    ],
    "productivity": [
      -132.3156443,
      -118.0569728,
      -106.8167898,
      -97.84905033,
      -90.44180562,
      -84.36863236,
      -78.87783606,
      -74.27099769,
      -69.24060246,
      -64.69736907,
      -61.1994112,
      -57.7068238,
      -54.62292916,
      -51.64316004,
      -48.67810135,
      -46.10983438,
      -43.56047398,
      -41.17408472,
      -38.82996736,
      -36.79188068,
      -34.68065022,
      -32.86714337,
      -31.05589298,
      -29.20786529,
      -27.49925238,
      -25.93636188,
      -24.47725915,
      -23.09440172,
      -21.7063402,
      -20.47138545,
      -19.23759735,
      -18.01364332,
      -16.84621666,
      -15.81829639,
      -14.67482117,
      -13.65846242,
      -12.67730806,
      -11.68736364,
      -10.64324774,
      -9.766505219,
      -8.768791953,
      -7.887056041,
      -7.010614771,
      -6.22268068,
      -5.31000262,
      -4.48188092,
      -3.569612593,
      -2.786028475,
      -1.957609681,
      -1.131642029,
      -0.2353283192,
      0.6335326133,
      1.46916808,
      2.345827519,
      3.21565253,
      4.201674219,
      5.052803274,
      5.882882336,
      6.753463957,
      7.64370177,
      8.576310493,
      9.491332027,
      10.44451109,
      11.37045211,
      12.28031763,
      13.286253,
      14.31585168,
      15.25752369,
      16.26686659,
      17.28203025,
      18.31243183,
      19.39079606,
      20.41640292,
      21.48964458,
      22.74516894,
      24.00029422,
      25.29298825,
      26.63469202,
      28.16301073,
      29.69186331,
      31.36566605,
      32.96504743,
      34.64809058,
      36.60371686,
      38.46252653,
      40.66826531,
      43.02242789,
      45.46557132,
      48.19627499,
      51.08371555,
      54.22458718,
      57.60374129,
      61.61751425,
      66.30067327,
      71.4273118,
      78.52366628,
      87.49379592,
      102.1282657,
      123.3078776
    ],
    "fertility": [
      -5.179730872,
      -4.562582974,
      -4.098974359,
      -3.723589744,
      -3.402620513,
      -3.097241026,
      -2.825105641,
      -2.549993846,
      -2.333729231,
      -2.123497436,
      -1.899471795,
      -1.705226667,
      -1.535384615,
      -1.353846154,
      -1.187730769,
      -1.022596923,
      -0.8663051282,
      -0.7235897436,
      -0.5985082051,
      -0.4615384615,
      -0.3430769231,
      -0.2249046154,
      -0.1129661538,
      -0.006153846154,
      0.0956025641,
      0.1989641026,
      0.3,
      0.3935897436,
      0.4974358974,
      0.5897435897,
      0.6861538462,
      0.7692307692,
      0.8577615385,
      0.9512820513,
      1.036923077,
      1.122194872,
      1.216925641,
      1.294871795,
      1.387692308,
      1.461538462,
      1.538717949,
      1.628974359,
      1.692307692,
      1.777037949,
      1.86,
      1.923076923,
      2.004517949,
      2.09105641,
      2.153846154,
      2.249230769,
      2.341025641,
      2.39784,
      2.479151282,
      2.569230769,
      2.619525641,
      2.71025641,
      2.804415385,
      2.853846154,
      2.951794872,
      3.047641026,
      3.096682051,
      3.182051282,
      3.266666667,
      3.311210256,
      3.402935897,
      3.495775385,
      3.538461538,
      3.630769231,
      3.735897436,
      3.779846154,
      3.887179487,
      3.995733333,
      4.046153846,
      4.15334359,
      4.2,
      4.306133333,
      4.362671795,
      4.461538462,
      4.546153846,
      4.615384615,
      4.723076923,
      4.799712821,
      4.923076923,
      5.021435897,
      5.140538462,
      5.230769231,
      5.358471795,
      5.492307692,
      5.636115385,
      5.789051282,
      5.96135641,
      6.126317949,
      6.307692308,
      6.578266667,
      6.8865,
      7.230769231,
      7.706912821,
      8.4,
      9.773333333
    ]
  }
}
